module.exports = __webpack_public_path__ + "media/sg_RM6.c98bd709.mp4";